// hooks/useBonuses.ts
import { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getApi } from '../../../../api/api'
import { setBonusData, selectBonusState } from '../../../../store/slices/bonusSlice'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'

export const useBonuses = () => {
  const dispatch = useDispatch()
  const [api] = useState(getApi())
  const { data: bonusData } = useSelector(selectBonusState)

  const cluster = useSelector(selectCurrentCluster)

  const [bonusesToSpend, setBonusesToSpend] = useState<number>(0)

  const loadBonuses = useCallback(async () => {
    try {
      const result = await api.getBonusBalance()

      if (result) {
        dispatch(setBonusData(result))
      }
    } catch (error) {
      console.error('Error loading bonuses:', error)
    }
  }, [api, dispatch])

  // Данные из кластера
  const writeOffPercent = cluster?.writeOff || 0
  const bonusRules = cluster?.bonuses || []

  return {
    // Из бонус слайса
    balance: bonusData.balance,
    totalSpent: bonusData.totalSpent,
    bonusPercent: bonusData.bonusPercent,

    // Из кластера
    writeOffPercent,
    bonusRules,

    // Для UI
    bonusesToSpend,
    setBonusesToSpend,
    loadBonuses,
  }
}
